/**
 * Tabs (design-system §7 · Tabs): subrayado coral de 2 px bajo la pestaña activa, texto 14 px/500,
 * activa en marino, inactiva en neutro. Radix Tabs aporta el patrón ARIA y las flechas.
 */
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '../../lib/cn';

import type { ComponentPropsWithoutRef } from 'react';

export const Tabs = TabsPrimitive.Root;

export function TabsList({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn('flex items-end gap-fm-4 border-b border-fm-border', className)}
      {...props}
    />
  );
}

export function TabsTrigger({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'h-fm-touch border-b-2 border-transparent px-fm-1 text-fm-sm font-medium text-fm-text-secondary',
        'transition-colors duration-fm-base ease-fm-standard motion-reduce:transition-none',
        'hover:text-fm-text focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fm-focus',
        'data-[state=active]:border-fm-primary data-[state=active]:text-fm-text',
        className,
      )}
      {...props}
    />
  );
}

export function TabsContent({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn(
        'pt-fm-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fm-focus',
        className,
      )}
      {...props}
    />
  );
}
